import { render, staticRenderFns } from "./Q3.vue?vue&type=template&id=10e53c5d&scoped=true&"
import script from "./Q3.vue?vue&type=script&lang=js&"
export * from "./Q3.vue?vue&type=script&lang=js&"
import style0 from "./Q3.vue?vue&type=style&index=0&id=10e53c5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e53c5d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VContainer})
